import React, { useEffect, useState } from "react";
import "./Admin.css";
import AdminSidebar from "./comon/AdminSidebar";
import Header from "./comon/Header";
import { Card, CardBody, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import {
  FaUsers,
  FaUserCheck,
  FaClock,
  FaVideo,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";

function Dashboard() {
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("userData");
    if (user) {
      setUserData(JSON.parse(user));
    }
  }, []);

  return (
    <div className="main-div">
      <AdminSidebar />

      <div className="fill-width">
        <Header />

        <div className="dashboard-container">

          {/* Welcome */}
          <div className="welcome-box">
            <h2>Welcome Back, {userData.fname}</h2>
            <p>Here’s what’s happening in your dashboard today.</p>
          </div>

          {/* Top Cards */}
          <div className="stats-grid">

            <div className="stats-card green">
              <FaUsers />
              <div>
                <h3>1,245</h3>
                <p>Total Users</p>
              </div>
            </div>

            <div className="stats-card blue">
              <FaUserCheck />
              <div>
                <h3>856</h3>
                <p>Verified Users</p>
              </div>
            </div>

            <div className="stats-card orange">
              <FaClock />
              <div>
                <h3>124</h3>
                <p>Pending Review</p>
              </div>
            </div>

            <div className="stats-card red">
              <FaVideo />
              <div>
                <h3>18</h3>
                <p>Video Calls</p>
              </div>
            </div>

          </div>

          {/* Profile Card */}
          <Card className="profile-card">
            <CardBody>
              <div className="row">

                {/* Left */}
                <div className="col-md-4">
                  <div className="profile-left">
                    <img
                      src={userData.profile_photo}
                      alt=""
                      className="profile-photo"
                    />
                    <h3>{userData.fname} {userData.lname}</h3>
                    <p>Administrator</p>
                  </div>
                </div>

                {/* Right */}
                <div className="col-md-8 profile-right">
                  <h4 className="section-title ">Profile Information</h4>

                  <div className="info-grid">
                    <div>
                      <span>First Name</span>
                      <p>{userData.fname}</p>
                    </div>

                    <div>
                      <span>Last Name</span>
                      <p>{userData.lname}</p>
                    </div>

                    <div>
                      <span>Email</span>
                      <p><FaEnvelope /> {userData.email}</p>
                    </div>

                    <div>
                      <span>Phone</span>
                      <p><FaPhone /> +{userData.phone}</p>
                    </div>

                    <div>
                      <span>Date of Birth</span>
                      <p>{userData.dob}</p>
                    </div>
                  </div>

                  {userData.lavel !== "1" && (
                    <Button
                      className="video-btn"
                      onClick={() => navigate("/admin/video")}
                    >
                      Start Video Interview
                    </Button>
                  )}
                </div>

              </div>
            </CardBody>
          </Card>

        </div>
      </div>
    </div>
  );
}

export default Dashboard;